package app.view

import app.CustomRouter
import app.Routes
import app.api.DeployablePaginatedApi
import app.components.pagination
import app.model.EcrDeployable
import app.model.LambdaDeployable
import app.model.S3Deployable
import app.svg.sort
import app.utils.formatDateTime
import dev.fritz2.core.RenderContext
import dev.fritz2.core.scope
import dev.fritz2.core.title

fun RenderContext.deployablePaginatedView(
    deployablePaginatedApi: DeployablePaginatedApi,
    deployableName: String?,
    page: Int,
    sort: String,
    order: String,
) {
    if (deployableName.isNullOrEmpty()) {
        CustomRouter.navTo(mapOf("route" to Routes.DEPLOYABLES))
        return
    }

    deployablePaginatedApi.handler(
        DeployablePaginatedApi.PaginationRequest(
            name = deployableName,
            sort = sort,
            order = order,
            page = page,
        )
    )
    deployablePaginatedApi.data.render { deployables ->
        div("relative overflow-x-auto shadow-md sm:rounded-lg mt-4 border dark:border-gray-700") {
            table("w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400") {
                thead("text-xs text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-300") {
                    tr("dark:text-gray-300") {
                        th("px-6 py-3") {
                            scope("col")
                            +"NAME"
                        }
                        th("px-6 py-3") {
                            scope("col")
                            div("flex items-center") {
                                button("flex ${if (sort == "version") "underline" else ""}") {
                                    +"VERSION"
                                    sort("w-3 h-3 ms-1.5")
                                    clicks handledBy {
                                        CustomRouter.deployable(
                                            mapOf(
                                                "route" to Routes.DEPLOYABLE,
                                                Routes.Params.DEPLOYABLE_NAME to deployableName,
                                                Routes.Params.SORT to "version",
                                                Routes.Params.ORDER to if (order == "asc") "desc" else "asc",
                                                Routes.Params.PAGE to "1"
                                            )
                                        )
                                    }
                                }
                            }
                        }
                        th("px-6 py-3") {
                            scope("col")
                            div("flex items-center") {
                                button("flex ${if (sort == "date") "underline" else ""}") {
                                    +"DATE"
                                    sort("w-3 h-3 ms-1.5")
                                    clicks handledBy {
                                        CustomRouter.deployable(
                                            mapOf(
                                                "route" to Routes.DEPLOYABLE,
                                                Routes.Params.DEPLOYABLE_NAME to deployableName,
                                                Routes.Params.SORT to "date",
                                                Routes.Params.ORDER to if (order == "asc") "desc" else "asc",
                                                Routes.Params.PAGE to "1"
                                            )
                                        )
                                    }
                                }
                            }
                        }
                        th("px-6 py-3") {
                            scope("col")
                            div("flex items-center") {
                                +"DATA"
                            }
                        }
                    }
                }
                tbody {
                    deployables.items.forEach { deployable ->
                        tr("bg-white border-b dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300") {
                            th("px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-gray-300") {
                                scope("row")
                                +deployable.name
                            }
                            td("px-6 py-4") {
                                +"${deployable.version}"
                            }
                            td("px-6 py-4") {
                                +formatDateTime(deployable.creationDate)
                            }
                            td("px-6 py-4") {
                                when (deployable.data) {
                                    is EcrDeployable -> {
                                        title("ECR")
                                        +deployable.data.imageTag
                                    }

                                    is LambdaDeployable -> {
                                        title("Lambda")
                                        +deployable.data.fileName
                                    }

                                    is S3Deployable -> {
                                        title("S3")
                                        +deployable.data.fileName
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        div("mt-4 flex justify-center") {
            pagination(
                currentPage = deployables.currentPage,
                totalPages = deployables.totalPages
            ) { newPage ->
                CustomRouter.deployable(
                    mapOf(
                        "route" to Routes.DEPLOYABLE,
                        Routes.Params.DEPLOYABLE_NAME to deployableName,
                        Routes.Params.SORT to sort,
                        Routes.Params.ORDER to order,
                        Routes.Params.PAGE to newPage.toString()
                    )
                )
            }
        }
    }
}
